const variables = {
  dateSectionBanner: undefined,
  showBrandSelectorLedge: false,
  showBrandSelectorSection: false,
};

export default variables;
